export const enum ProductSliderVariant
{
    OtherXLs
}